/* Bocock homepage rail controls.
   The rails scroll horizontally under 760px and gave no signal that there was
   anything to the right. This adds the hint line, the two arrows at 48px so they
   clear the tap target minimum, a position counter and a progress bar.

   The counter is the part that does the work. It tells the visitor there are four,
   not that there might be more.

   The prev arrow reads the rail's computed padding-left rather than testing
   scrollLeft against zero. Scroll snap rests the first card at the padding offset,
   so scrollLeft is never actually 0 and the arrow would otherwise never disable.
   That exact bug is in the July 26 worklog at scrollLeft:2. */
(function () {
  function init(rail) {
    if (rail.dataset.bkrail === '1') return;
    rail.dataset.bkrail = '1';

    var nav = document.createElement('div');
    nav.className = 'bkrailnav';
    nav.innerHTML =
      '<span class="hint">Swipe or tap to see all</span>' +
      '<div class="row">' +
      '<button type="button" class="prev" aria-label="Previous"><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M8.2 0.6 L3 6 l5.2 5.4 1.2-1.2L5.4 6l4-4.2z"/></svg></button>' +
      '<span class="count"></span>' +
      '<button type="button" class="next" aria-label="Next"><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3.8 0.6 L2.6 1.8 6.6 6l-4 4.2 1.2 1.2L9 6z"/></svg></button>' +
      '</div>' +
      '<span class="track"><i></i></span>';
    rail.parentNode.insertBefore(nav, rail.nextSibling);

    var prev = nav.querySelector('.prev');
    var next = nav.querySelector('.next');
    var count = nav.querySelector('.count');
    var fill = nav.querySelector('.track i');
    var cards = rail.children;

    function scrollable() {
      return rail.scrollWidth > rail.clientWidth + 4;
    }

    function step() {
      var a = cards[0], b = cards[1];
      if (a && b) return b.getBoundingClientRect().left - a.getBoundingClientRect().left;
      return rail.clientWidth * 0.8;
    }

    function sync() {
      nav.classList.toggle('on', scrollable());
      if (!scrollable()) return;
      var padL = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      var max = rail.scrollWidth - rail.clientWidth;
      var pos = rail.scrollLeft;
      prev.disabled = pos <= padL + 4;
      next.disabled = pos >= max - 4;
      var n = cards.length;
      var i = Math.min(n, Math.round(pos / step()) + 1);
      count.textContent = i + ' / ' + n;
      fill.style.width = Math.max(6, Math.min(100, ((pos + rail.clientWidth) / rail.scrollWidth) * 100)) + '%';
    }

    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('.bkrail').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
